import React, { useReducer, useEffect, useContext } from 'react';

import { Button, Form } from 'react-bootstrap';
import ReactDOM from "react-dom";
import { 
	DOCKET_PREFIXES, 
	FEE_OPTIONS, 
	COUNTRIES, 
	AFFILIATION_LIST, 
	ATTENTION_LIST, 
} from "../../resources/constants/dropdowns";
import FilingParty from './components/FilingParty';
import FileAttachment from './components/FileAttachment';
import { AttachmentWithPrivacy, getFieldsForType, getSubmitButtonLabel, getEFilingSubmitCheckbox} from './components/common';
import { PARTY_DIV_ID, ATTACHMENTS_DIV_ID } from '../../resources/constants/ui';
import { getErrors, validateFilingByType } from './util/validation';
import { 
	FORMAL_FILING_FORM_TYPE, 
	OTHER_FILING_FORM_TYPE, 
	RECORDATION_FORM_TYPE, 
	PARTY_LABEL, 
	RECORDATION_DATE_OF_AGREEMENT_FIELD, 
	EMAIL_FIELD, 
	PHONE_FIELD, 
	COUNTRY_FIELD, 
	ZIP_FIELD, 
	STATE_FIELD, 
	CITY_FIELD, 
	ADDRESS_TWO_FIELD, 
	ADDRESS_ONE_FIELD, 
	COMPANY_FIELD, 
	SUBMITTER_FIELD, 
	CONFIRMATION_NUM_FIELD, 
	PRIMARY_RECORDATION_NUM_FIELD, 
	RECORDATION_OPTION_FIELD, 
	RECORDATION_TYPE_OF_AGREEMENT_FIELD, 
	HAC_FIELD, 
	EQUIPMENT_DESCRIPTION_FIELD, 
	RCPA_FORM_TYPE, 
	JOB_TITLE_FIELD, 
	FAX_FIELD, 
	ISSUE_FIELD, 
	COMMODITY_GROUP_FIELD, 
	REGION_FIELD, 
	RAILROADS_INVOLVED_FIELD, 
	PROBLEM_LOCATION_FIELD, 
	INDUSTRY_LOCATION_FIELD, 
	PROBLEM_DATES_FIELD, 
	ISSUE_SUMMARY_FIELD, 
	CONTACT_PERMISSION_FIELD, 
	ENVIRONMENTAL_COMMENTS_FORM_TYPE, 
	DOCKET_NUMBERS_FIELD, 
	DOCKET_PREFIX_FIELD, 
	SEQUENCE_NUM_FIELD, 
	SUBSEQUENCE_NUM_FIELD, 
	DOCKET_SUFFIX_FIELD,
	ENVCOM_PROJECT_FIELD,
	ENVCOM_ATTENTION_FIELD,
	ENVCOM_YOUR_NAME_FIELD,
	ENVCOM_ORGANIZATION_FIELD,
	ENVCOM_AFFILIATION_FIELD,
	ENVCOM_COMMENTS_FIELD,
	ENVCOM_HAVE_DOCKETS_FIELD,
	EFILING_SUBMIT_CHECKBOX_FIELD
} from '../../resources/constants/fields';
import reducer from "./util/reducer";
import { sendDataAsync } from '../../resources/util/upload';
import { CORRECT_THE_FOLLOWING_TITLE } from '../../resources/constants/errors';
import Confirmation from './Confirmation';
import { MAX_ATTACHMENTS_RCPA, MAX_ATTACHMENTS_RECORDATIONS, MAX_ATTACHMENTS_FILING, MAX_ATTACHMENTS_ENVCOM } from '../../resources/constants/validations';
import Modal from "./components/modal"

const StateContext = React.createContext(
  /* optional default value */
);

const StateProvider = ({reducer, initialState, children}) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
);

const useStateValue = () => useContext(StateContext);

const FormStateProvider = props => {
	var initialState = { 
		form: {
			type: props.filingType,
			validated: false,
			formSubmitted: false,
			errors: [],
			networkErrors: [],
			uniqueErrors: [],
			loading: false,
			success: false
		}
	};
    if(props.filingType === OTHER_FILING_FORM_TYPE) {
	    initialState.data = {
			docketNumbers: [{
				[DOCKET_PREFIX_FIELD]: DOCKET_PREFIXES[0],
				[SEQUENCE_NUM_FIELD]: "",
				[SUBSEQUENCE_NUM_FIELD]: "",
				[DOCKET_SUFFIX_FIELD]: ""
			}],
			isOtherFiling: true,
			parties: [new FilingParty()],
			attachments: [new FileAttachment()],
			isPublic: [true],
			attachmentStrings: [],
			[EFILING_SUBMIT_CHECKBOX_FIELD]: false,
		};
		initialState.form.maxAttachments = MAX_ATTACHMENTS_FILING;
		initialState.form.attachmentProps = {
			inline: false,
			withPublic: true
		};
	} else if(props.filingType === FORMAL_FILING_FORM_TYPE) {
		initialState.data= {
			docketNumbers: [{
				[DOCKET_PREFIX_FIELD]: DOCKET_PREFIXES[0],
				[SEQUENCE_NUM_FIELD]: "",
				[SUBSEQUENCE_NUM_FIELD]: "",
				[DOCKET_SUFFIX_FIELD]: ""
			}],
			feeOption: FEE_OPTIONS[0].value,
			confirmationNumber: "",
			isOtherFiling: false,
			parties: [new FilingParty()],
			attachments: [new FileAttachment()],
			isPublic: [true],
			attachmentStrings: [],
			[EFILING_SUBMIT_CHECKBOX_FIELD]: false
		};
		initialState.form.maxAttachments = MAX_ATTACHMENTS_FILING;
		initialState.form.attachmentProps = {
			inline: false,
			withPublic: true
		};
	} else if(props.filingType === RECORDATION_FORM_TYPE) {
		initialState.data= {
			[RECORDATION_OPTION_FIELD]: null,
			[PRIMARY_RECORDATION_NUM_FIELD]: "",
			[CONFIRMATION_NUM_FIELD]: "",
			[SUBMITTER_FIELD]: "",
			[COMPANY_FIELD]: "",
			[ADDRESS_ONE_FIELD]: "",
			[ADDRESS_TWO_FIELD]: "",
			[CITY_FIELD]: "",
			[STATE_FIELD]: "",
			[ZIP_FIELD]: "",
			[COUNTRY_FIELD]: COUNTRIES[0],
			[PHONE_FIELD]: "",
			[EMAIL_FIELD]: "",
			[RECORDATION_DATE_OF_AGREEMENT_FIELD]: "",
			[RECORDATION_TYPE_OF_AGREEMENT_FIELD]: "",
			[HAC_FIELD]: "false",
			[EQUIPMENT_DESCRIPTION_FIELD]: '',
			file: '',
			parties: [new FilingParty()],
			isPublic: [true],
			attachmentStrings: [],
			attachments: [new FileAttachment()],
			[EFILING_SUBMIT_CHECKBOX_FIELD]: false
		};
		initialState.form.maxAttachments = MAX_ATTACHMENTS_RECORDATIONS;
		initialState.form.attachmentProps = {
			inline: true,
			withPublic: false
		}
	} else if(props.filingType === RCPA_FORM_TYPE) {
		initialState.data= {
			[SUBMITTER_FIELD]: "",
			[COMPANY_FIELD]: "",
			[JOB_TITLE_FIELD]: "",
			[ADDRESS_ONE_FIELD]: "",
			[ADDRESS_TWO_FIELD]: "",
			[CITY_FIELD]: "",
			[STATE_FIELD]: "",
			[ZIP_FIELD]: "",
			[COUNTRY_FIELD]: COUNTRIES[0],
			[EMAIL_FIELD]: "",
			[PHONE_FIELD]: "",
			[FAX_FIELD]: "",
			[ISSUE_FIELD]: "",
			[COMMODITY_GROUP_FIELD]: "",
			[REGION_FIELD]: "",
			[RAILROADS_INVOLVED_FIELD]: "",
			[PROBLEM_LOCATION_FIELD]: "",
			[INDUSTRY_LOCATION_FIELD]: "",
			[PROBLEM_DATES_FIELD]: "",
			[ISSUE_SUMMARY_FIELD]: "",
			[CONTACT_PERMISSION_FIELD]: "",
			file: '',
			parties: [new FilingParty()],
			isPublic: [true],
			attachmentStrings: [],
			attachments: [new FileAttachment()]
		};
		initialState.form.maxAttachments = MAX_ATTACHMENTS_RCPA;
		initialState.form.attachmentProps = {
			inline: true,
			withPublic: false
		};
	} else if(props.filingType === ENVIRONMENTAL_COMMENTS_FORM_TYPE) {
		initialState.data= {
			[ENVCOM_HAVE_DOCKETS_FIELD]: null,
			[DOCKET_NUMBERS_FIELD]: [],
			[ENVCOM_PROJECT_FIELD]: "",
			[ENVCOM_ATTENTION_FIELD]: ATTENTION_LIST[0],
			[ENVCOM_YOUR_NAME_FIELD]: "",
			[ENVCOM_ORGANIZATION_FIELD]: "",
			[ENVCOM_AFFILIATION_FIELD]: AFFILIATION_LIST[0],
			[ADDRESS_ONE_FIELD]: "",
			[ADDRESS_TWO_FIELD]: "",
			[CITY_FIELD]: "",
			[STATE_FIELD]: "",
			[ZIP_FIELD]: "",
			[COUNTRY_FIELD]: COUNTRIES[0],
			[PHONE_FIELD]: "",
			[EMAIL_FIELD]: "",
			[ENVCOM_COMMENTS_FIELD]: "",
			file: '',
			parties: [new FilingParty()],
			isPublic: [true],
			attachmentStrings: [],
			attachments: [new FileAttachment()],
			[EFILING_SUBMIT_CHECKBOX_FIELD]: false
		};
		initialState.form.maxAttachments = MAX_ATTACHMENTS_ENVCOM;
		initialState.form.attachmentProps = {
			inline: true,
			withPublic: false
		};
	} 
	
	return (
		<StateProvider initialState={initialState} reducer={reducer}>
			<EFiling parentHistory={props.history}/>
		</StateProvider>
	);
}

const handleSubmit = async (state, dispatch, event, parentHistory) => {
	dispatch({type: "setState", newState: { form: {...state.form, loading: true, networkErrors: [], formSubmitted: true } } });
	const form = event.currentTarget;
	if (form.checkValidity() === false) {
		dispatch({type: "setState", newState: { form: {...state.form, loading: false, networkErrors: [], formSubmitted: true } } });
		event.preventDefault();
		event.stopPropagation();
		window.scrollTo(0,0);
	} else {
		let errors = validateFilingByType(state);
		if (errors.length) {
			dispatch({type: "setState", newState: { form: {...state.form, errors: errors, loading: false, networkErrors: [], formSubmitted: true } } });
			event.preventDefault();
			event.stopPropagation();
			window.scrollTo(0,0);
		} else {
			await sendDataAsync(state, dispatch, event, parentHistory);
		}
	}
}


const EFilingForm = props => {
	var [state, dispatch] = useStateValue();
	
	return (
		<React.Fragment>
			 <div id="Efiling" key="Efiling">
				<Form
					noValidate
					validated={state.form.validated}
					onSubmit={handleSubmit}
				>
					{state.form.errors.length > 0 && state.form.formSubmitted ? (
						<div className="invalid-feedback invalid-feedback--large show ">
							<span className="error-title"><strong>{CORRECT_THE_FOLLOWING_TITLE}</strong>{getErrors(state.form)}</span>
						</div>
					) : (
						""
					)}
					{getFieldsForType(state, dispatch)}
					<br />
					{getEFilingSubmitCheckbox(state, dispatch)}
					<br />
					<div>
						<Button
							className="stb-button-submit auto-margin"
							onClick={e => { e.persist(); handleSubmit(state, dispatch, e, props.parentHistory)}}
							disabled={state.form.errors.length > 0 || state.form.loading}
						>
							{getSubmitButtonLabel(state)}
						</Button>
						{state.form.networkErrors.length > 0 ? (
							<div className="center invalid-feedback show">
								{state.form.networkErrors
									? getErrors(state.form)
									: null}
							</div>
						) : (
							""
						)}
					</div>
					<br />
					{state.form.loading ? (
						<Modal />
					) : (
						""
					)}
				</Form>
			</div>
		</React.Fragment>
	)
}

const EFiling = props => {
  var [state, dispatch] = useStateValue();
  useEffect(() => {
	renderParties(state, dispatch);
	renderAttachments(state, dispatch);
	return () => {
		//cleanup code runs on unmount
	};

	});
	if(state.form.success){
		return (<Confirmation filingType={state.form.type}/>);
	} else {
		return (
			<EFilingForm parentHistory={props.parentHistory}/>
		);
	}
}

const renderParties = (state, dispatch) => {
	let targetContainer = document.getElementById(PARTY_DIV_ID);
	if(state && state.data.parties && targetContainer){
		ReactDOM.render(
			state.data.parties.map((val, idx) => (
				<FilingParty
					index={idx}
					key={`${PARTY_LABEL}-${idx}`}
					total={state.data.parties.length}
					remove={(partyIndex) => {dispatch({type: "removeParty", partyIndex: partyIndex})}}
					addEmail={(partyIndex) => {dispatch({type: "addEmail", partyIndex: partyIndex})}}
					removeEmail={(partyIndex, emailIndex) => {dispatch({type: "removeEmail", partyIndex: partyIndex, emailIndex: emailIndex})}}
					party={{ state: val.state }}
					type={state.form.type}
					handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
					handleBlur={(e) => { e.persist(); dispatch({type: "handleBlur", event: e })}}
					errors={state.form.errors}
				/>
			)),
			targetContainer
		);
	}
};

const renderAttachments = (state, dispatch) => {
	let targetContainer = document.getElementById(ATTACHMENTS_DIV_ID);
	if(state && state.data.attachments && targetContainer){
		ReactDOM.render(
			<AttachmentWithPrivacy
				attachments={state.data.attachments}
				total={state.data.attachments.length}
				handleChange={(e) => { e.persist(); dispatch({type: "handleChange", event: e })}}
				onClick={(e) => { e.persist(); dispatch({type: "clickAttachment", event: e })}}
				public={state.data.isPublic}
				remove={(index) => { dispatch({type: "removeAttachment", index: index})}}
				errors={state.form.errors}
				valid={!state.form.validated}
				formType={state.form.type}
				{...state.form.attachmentProps}
			/>,
			targetContainer
		);
	}
};

export default FormStateProvider;
